/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Manage_Rename_SavedInputs */

const en_us2_coach_manage_rename_saved = /** @type {(inputs: Coach_Manage_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation renamed`)
};

const pt_br2_coach_manage_rename_saved = /** @type {(inputs: Coach_Manage_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa renomeada`)
};

const es_419_coach_manage_rename_saved = /** @type {(inputs: Coach_Manage_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación renombrada`)
};

const pt_pt2_coach_manage_rename_saved = /** @type {(inputs: Coach_Manage_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da conversa alterado`)
};

const fr_fr2_coach_manage_rename_saved = /** @type {(inputs: Coach_Manage_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation renommée`)
};

const de_de2_coach_manage_rename_saved = /** @type {(inputs: Coach_Manage_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung umbenannt`)
};

const it_it2_coach_manage_rename_saved = /** @type {(inputs: Coach_Manage_Rename_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazione rinominata`)
};

/**
* | output |
* | --- |
* | "Conversation renamed" |
*
* @param {Coach_Manage_Rename_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_manage_rename_saved = /** @type {((inputs?: Coach_Manage_Rename_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Manage_Rename_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_manage_rename_saved(inputs)
	if (locale === "es-419") return es_419_coach_manage_rename_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_manage_rename_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_manage_rename_saved(inputs)
	if (locale === "de-DE") return de_de2_coach_manage_rename_saved(inputs)
	if (locale === "it-IT") return it_it2_coach_manage_rename_saved(inputs)
	return en_us2_coach_manage_rename_saved(inputs)
});
export { coach_manage_rename_saved as "coach-manage.rename_saved" }